import type { HttpClient } from './http';
import type {
  FeatureFlagKey,
  FeatureFlags,
  FeatureFlagsResponse,
} from './types';

export interface FeatureFlagsApi {
  getMyFlags(): Promise<FeatureFlagsResponse>;
  updateUserFlags(userId: string, flags: FeatureFlags): Promise<void>;
  toggleOrgFeature(
    organizationId: string,
    key: FeatureFlagKey,
    enabled: boolean
  ): Promise<void>;
}

export function createFeatureFlagsApi(http: HttpClient): FeatureFlagsApi {
  return {
    getMyFlags: () => http.get<FeatureFlagsResponse>('/feature-flags'),
    updateUserFlags: async (userId, flags) => {
      await http.put<void>(`/admin/feature-flags/user/${userId}`, { flags });
    },
    toggleOrgFeature: async (organizationId, key, enabled) => {
      await http.post<void>(
        `/admin/feature-flags/org/${organizationId}/toggle`,
        {
          key,
          enabled,
        }
      );
    },
  };
}
